/*
 * @Descripttion: 
 * @version: 
 * @Author: Terry
 * @Date: 2020-06-04 17:18:56
 * @LastEditors: Terry
 * @LastEditTime: 2022-04-16 20:01:00
 */ 

// element
import Vue from "vue";
import store from "./store";
import ElementUI from 'element-ui';
import {router} from '@/router';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

import App from "./App.vue";

// // app.js
import './assets/css/app.css'
import axios from '@/utils/axios.js'
Vue.prototype.axios = axios;

//moment.js
import moment from 'moment';
Vue.prototype.$moment = moment
import api from '@/api';
Vue.prototype.api = api;
Vue.use(ElementUI);

Vue.prototype.loading = function() {
  const loading = this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '正在加载...',                     // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.3)',       // 背景颜色
    target: '.sub-main',                    // 需要遮罩的区域
    body: true,                              
    customClass: 'mask'                     // 遮罩层新增类名
  })
  return loading;
}

//引入dataV
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
//  添加路由导航守卫0
router.beforeEach(async (to, from, next) => {
  // 获取token
  var token = sessionStorage.getItem('auxfaceToken')
  // 获取项目uuid 和公司uuid
  if (token==undefined || token=='undefined') {
    // 没有登陆的情况下，非登陆页面均跳转登陆页面
    if(to.path == '/login') next();
    else next({ name: 'login' });
  }else {
    /*登录成功下，访问登陆页面
    */
    if(to.path == '/login'||to.path == '/'){
      next({name:'prjList'});
    }
    else {
        next();
    } 
  }
  })
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
